// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contentWrapper":"_3LZGx","title":"_36j2n","createDate":"_1xQqz"};